/**
 * Token claims structure for FlowIO JWT tokens.
 * WP-AUTH-15: Login-time state computation.
 */
export interface TrialClaims {
  is_trialing: boolean;
  is_expired: boolean;
  days_remaining: number;
  trial_ends_at: string | null;
}

export interface TokenClaims {
  sub: string;
  tenant_id: string;
  trial?: TrialClaims;
  entitlements?: string[];
  session_id?: string;
  exp: number;
  iat: number;
  jti: string;
  type: 'access' | 'refresh';
}

/**
 * Decode JWT token claims.
 *
 * WARNING: This does NOT validate the token signature.
 * Only use for reading claims from tokens already validated by the backend.
 */
export function decodeTokenClaims(token: string): TokenClaims {
  const parts = token.split('.');
  if (parts.length !== 3) {
    throw new Error('Invalid token format');
  }
  // parts[1] is guaranteed to exist after length check
  const payload = parts[1] as string;
  return JSON.parse(atob(payload)) as TokenClaims;
}
